import { render, staticRenderFns } from "./WidowedYearOfDeath.vue?vue&type=template&id=462f097e"
import script from "./WidowedYearOfDeath.vue?vue&type=script&lang=js"
export * from "./WidowedYearOfDeath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports